// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setUiSetting, getUiSetting } from '../../store/uiStore';
import { breakpointsPx } from '../../helpers/breakpoints';

type StateProps = {|
  slidersEnabled: ?boolean,
|};

type DispatchProps = {|
  disableSliders: Function,
  enableSliders: Function,
|};

type Props = {|
  ...StateProps,
  ...DispatchProps,
|};

// @TODO: create HoC typing https://justlease.atlassian.net/browse/LISTO-308
const withSliderObserver = (WrappedComponent: any) => {
  class Watcher extends Component<Props> {
    componentDidMount() {
      this.shouldSlide();
      window.addEventListener('resize', this.resizeHandler);
    }

    resizeHandler = () => {
      this.shouldSlide();
    }

    shouldSlide() {
      const {
        disableSliders,
        slidersEnabled,
        enableSliders,
      } = this.props;

      if (window.innerWidth < breakpointsPx.xl) {
        if (!slidersEnabled) {
          enableSliders();
        }
        return;
      }

      if (slidersEnabled) {
        disableSliders();
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }


  const mapStateToProps = (state): StateProps => ({
    slidersEnabled: getUiSetting(state, 'slidersEnabled'),
  });

  const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    disableSliders: () => dispatch(setUiSetting('slidersEnabled', false)),
    enableSliders: () => dispatch(setUiSetting('slidersEnabled', true)),
  });

  return connect<Props, any, StateProps, DispatchProps, any, any>(
    mapStateToProps,
    mapDispatchToProps,
  )(Watcher);
};

export default withSliderObserver;
